// extracted by mini-css-extract-plugin
export default {"loading":"loader_loading__hC+mM"};